var GB = 1024 * 1024 * 1024;
var adminUser = {};
adminUser.email = "";
adminUser.account = "";
adminUser.accounts = [];
adminUser.tokenAccounts = {};
adminUser.pic = "";
adminUser.name = "...";
adminUser.refControl = false;
adminUser.fbUser = null;
adminUser.axios = null;
adminUser.server = "";
adminUser.mediaServer = "";
adminUser.licenceNo = 1;
adminUser.displayCount = 0;
adminUser.maxStorage = 0.2 * GB;
adminUser.totalStorage = 0;
adminUser.totalStorageStr = "0KB";
adminUser.accessDenied = false;
adminUser.db = {};
const axios = require("axios");
import store from "../../store.js";
const utils = require("@/classes/utils/utils.js").Utils;
const logs = require("@/classes/logs/logs.js").Logs;

adminUser.getEmail = function() {
  if (adminUser.email == "") return false;
  return adminUser.email;
};
adminUser.onLogin = function() {};
adminUser.sendToServerData = async function(
  method,
  url,
  data,
  callback,
  always
) {
  var res = await adminUser.getAxios();
  if (!res) return;
  store.commit("loading", true);
  this.axios({
    method: method,
    url: url,
    data: data,
  })
    .then(function(response) {
      // handle success

      if (response && response.data)
        if (!response.data.status && response.data.data) {
          if (response.data.data.access === false) {
            adminUser.accessDenied = true;
          }
        }
      if (response && response.data) if (callback) callback(response.data);
    })
    .catch(function(error) {
      // handle error
      console.error(error);
    })
    .then(function() {
      store.commit("loading", false);
      store.commit("loadingBG", false);
      if (always) always();
    });
};

adminUser.sendToServer = async function(method, url, callback, always) {
  var res = await adminUser.getAxios();
  if (!res) return;
  store.commit("loading", true);
  this.axios({
    timeout: 120000,
    method: method,
    url: url,
  })
    .then(function(response) {
      // handle success

      if (response && response.data)
        if (!response.data.status && response.data.data) {
          if (response.data.data.account_disabled === true) {
            adminUser.accountDisabled = true;
            adminUser.accessDenied = true;
          }
          if (response.data.data.access === false) {
            adminUser.accessDenied = true;
          }
        }
      if (callback) callback(response.data);
    })
    .catch(function(error) {
      // handle error
      console.error(error);
    })
    .then(function() {
      store.commit("loadingBG", false);
      store.commit("loading", false);
      if (always) always();
    });
};

adminUser.sendToMediaServer = async function(method, url, callback, always) {
  await adminUser.getAxios();
  this.mediaAxios({
    method: method,
    url: url,
  })
    .then(function(response) {
      // handle success
      if (response && response.data) if (callback) callback(response.data);
    })
    .catch(function(error) {
      // handle error
      console.error(error);
    })
    .then(function() {
      if (always) always();
    });
};

adminUser.updateTokenID = function() {
  let baseURL = adminUser.server + "/v1/api/";
  var domain = document.domain;
  if (domain == "easysignage-admin-test.web.app") {
    domain = "test.easysignage.app";
    baseURL = "https://devadmin-lf6pnk4rya-uc.a.run.app/v1/api/";
  }
  if (typeof webpackHotUpdate === "function") {
    domain = "vitrinemedia.easysignage.app";
    baseURL = "https://easysignageadmin-lf6pnk4rya-uc.a.run.app/v1/api/";
    //  baseURL = "http://localhost:8082/v1/api/";
  }
  adminUser.fbUser
    .getIdToken()
    .then((idToken) => {
      adminUser.idToken = idToken;
      adminUser.axios = axios.create({
        baseURL: baseURL,
        timeout: 20000,
        headers: {
          "X-Token": idToken,
          "X-Email": adminUser.email,
          "X-Domain": domain,
        },
      });

      adminUser.onLogin();
    })
    .catch((error) => {
      console.error(error);
    });
  adminUser.updateBrand();
};

adminUser.getToken = function(user) {
  user
    .getIdTokenResult()
    .then((idTokenResult) => {
      logs.print(idTokenResult.claims);
      adminUser.tokenAccounts = idTokenResult.claims.accounts;
    })
    .catch((error) => {
      console.error(error);
    });
};

adminUser.getDNotificationItem = function(doc) {
  var obj = {
    key: doc.id,
    val: false,
  };

  var data = doc.data();
  if (!data) return obj;
  obj.val = data;

  obj.val.action = (e) => {
    if (data.page) window.getApp.$router.push(data.page);
  };
  switch (obj.key) {
    case "player_no_content":
    case "player_licence_expired":
      obj.val.icon = "fa-light fa-triangle-exclamation";
  }
  switch (data.level) {
    case "warning":
      obj.val.color = "warning";
      break;
    case "danger":
      obj.val.color = "red";
      break;
  }
  if (adminUser.lang[data.text]) {
    obj.val.text = adminUser.lang[data.text];
  }
  return obj;
};

adminUser.getLang = function(text) {
  if (adminUser.lang[text]) return adminUser.lang[text];
  return text;
};

adminUser.RemoveNotifications = function(id) {
  switch (id) {
    case "player_no_content":
    case "player_licence_expired":
      break;
    default:
      return;
  }

  adminUser.db.usersCollection
    .doc(adminUser.account)
    .collection("notifications")
    .doc(id)
    .delete();
};

adminUser.AddNotifications = function(id) {
  var obj = {};
  switch (id) {
    case "player_no_content":
      obj.level = "warning";
      obj.page = "/displays";
      obj.text = "player_no_content_notification";
      break;
    case "player_licence_expired":
      obj.level = "danger";
      obj.page = "/displays";
      obj.text = "player_no_licence";
      break;
  }
  if (obj.text)
    adminUser.db.usersCollection
      .doc(adminUser.account)
      .collection("notifications")
      .doc(id)
      .set(obj);
};

adminUser.check_licences = function() {
  if (adminUser.displayCount > adminUser.licenceNo)
    adminUser.AddNotifications("player_licence_expired");
  else {
    adminUser.RemoveNotifications("player_licence_expired");
  }
};
adminUser.listenNotifications = async function() {
  if (adminUser.listeningToNotifications) return;
  adminUser.listeningToNotifications = true;
  var me = this;
  var account = await adminUser.getAccount();
  store.commit("reset_notifications");
  adminUser.db.usersCollection
    .doc(account)
    .collection("notifications")
    .onSnapshot(function(snapshot) {
      snapshot.docChanges().forEach((change) => {
        var doc = change.doc;

        // A new transaction has been added
        if (change.type === "added") {
          var item = me.getDNotificationItem(doc);

          store.commit("add_notifications", item);
        }
        // A transaction has been deleted
        if (change.type === "removed") {
          var item = me.getDNotificationItem(doc);
          store.commit("remove_notifications", item);
        }
        // A transaction has been modified
        if (change.type === "modified") {
          var item = me.getDNotificationItem(doc);
          store.commit("add_notifications", item);
        }
      });
    });
};

adminUser.getAxios = function() {
  //adminUser.axios

  let get = function() {
    if (adminUser.axios != null) return adminUser.axios;

    return false;
  };
  return new Promise(function(resolve, reject) {
    let count = 0;

    function tryGet() {
      let res = get();
      if (!res) {
        count++;
        if (count > 20) {
          //10 secs
          console.error("could not get axios");
          // resolve(adminUser.email);
          resolve(false);
          return;
        }
        setTimeout(tryGet, 500);
        return;
      }
      resolve(res);
    }
    tryGet();
  });
};
adminUser.getAccount = function() {
  return adminUser.email;
  /*
    let get = function () {
        if (adminUser.account != "")
            return adminUser.account
        if (adminUser.accounts && adminUser.accounts.length > 0)
            return adminUser.accounts[0]
        return false
    }
    return new Promise(function (resolve, reject) {
        let count = 0;

        function tryGet() {
            let res = get()
            if (!res) {
                count++
                if (count > 10) {
                    console.error("could not get account")
                    resolve(adminUser.email);
                    return
                }
                setTimeout(tryGet, 1000)
                return
            }
            resolve(res);
        }
        tryGet();
    });*/
};

adminUser.updateBrand = async function() {
  if (adminUser.brand_id) return;
  await adminUser.getAccount();
  return new Promise((resolve, reject) => {
    try {
      adminUser.sendToServer(
        "get",
        "/billing/brand",
        function(res) {
          if (!res.status) reject();
          adminUser.brand_id = res.data;
          resolve();
        },
        function() {}
      );
    } catch (err) {
      reject(err);
    }
  });
};

adminUser.getInvoices = async function() {
  await adminUser.getAccount();
  return new Promise((resolve, reject) => {
    try {
      adminUser.sendToServer(
        "get",
        "/billing/invoices",
        function(res) {
          if (!res.status) reject();
          resolve(res.data);
        },
        function() {}
      );
    } catch (err) {
      reject(err);
    }
  });
};

adminUser.openBilling = async function(callback) {
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/billing/customer_portal",
    function(res) {
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};

adminUser.clearServerCache = async function(callback) {
  await adminUser.getAccount();
  adminUser.sendToServer(
    "post",
    "/cache/clear",
    function(res) {
      logs.print("clearServerCache", res);
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};

adminUser.getUserDetails = async function(email, callback) {
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/users/" + email,
    function(res) {
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};

adminUser.getPlayersSummary = async function(callback) {
  logs.print("getPlayersSummary");
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/players/summary",
    function(res) {
      logs.print("getPlayersSummary", res);
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};

adminUser.getUserPlayers = async function(email, callback) {
  logs.print("getUserPlayers");
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/players/user/" + email,
    function(res) {
      logs.print("getUserPlayers", res);
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};
adminUser.getUserSubUsers = async function(email, callback) {
  logs.print("getUserSubUsers");
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/users/" + email + "/sub_users",
    function(res) {
      logs.print("getUserSubUsers", res);
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};
adminUser.getAllPlayers = async function(callback) {
  logs.print("getAllPlayers");
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/players",
    function(res) {
      logs.print("getAllPlayers", res);
      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};
adminUser.fixUser = function(user) {
  if (!user.location) {
    user.location = {};
    user.location.cf_country = "-";
    user.location.country_name = "-";
  } else {
    user.location.country_name = utils.getCountry(user.location.cf_country);
  }
  if (user.status === undefined) user.status = true;
  return user;
};

adminUser.getAllUsers = async function(callback) {
  logs.print("getAllUsers");
  await adminUser.getAccount();
  adminUser.sendToServer(
    "get",
    "/users",
    function(res) {
      logs.print("getAllUsers", res);

      if (callback) {
        callback(res);
      }
    },
    function() {}
  );
};

adminUser.updateMaxStorage = function(max) {
  adminUser.maxStorage = max;
  adminUser.maxStorageStr = adminUser.humanFileSize(adminUser.maxStorage);
};
adminUser.updateLicenceNo = function(licenceNo) {
  adminUser.licenceNo = licenceNo;
  adminUser.check_licences();
};
adminUser.listenSettings = async function() {
  if (adminUser.settingsListener) adminUser.settingsListener();
  var account = await adminUser.getAccount();

  adminUser.settingsListener = adminUser.db.usersCollection
    .doc(account)
    .collection("accountSettings")
    .onSnapshot(function(snapshot) {
      snapshot.docChanges().forEach((change) => {
        var doc = change.doc;
        if (doc.exists) {
          var data = doc.data();
          switch (doc.id) {
            case "storageStatus":
              adminUser.totalStorageStr = data.totalStorageStr;
              adminUser.totalStorage = data.totalStorage;
              break;
            case "storageLeft":
              adminUser.storageLeftInBytes = data.storageLeftInBytes;
              break;
            case "conf":
              if (data.maxStorage) {
                adminUser.updateMaxStorage(data.maxStorage);
              }
              break;
            case "licences":
              if (data.licenceNo) {
                adminUser.updateLicenceNo(data.licenceNo);
              }
              break;
            case "displayCount":
              if (data.displayCount) {
                adminUser.displayCount = data.displayCount;
                adminUser.check_licences();
              }
              break;
          }
        }
      });
    });
};
adminUser.listen = async function() {
  if (adminUser.listenSub) adminUser.listenSub();
  adminUser.listenSub = adminUser.docRef.onSnapshot({}, function(doc) {
    var data = doc.data();

    adminUser.account = data.account;
    adminUser.name = data.name;
    setTimeout(adminUser.initTawk, 2000);
  });
};
adminUser.AccountListen = async function() {
  if (adminUser.AccountListenSub) adminUser.AccountListenSub();
  var account = await adminUser.getAccount();
  adminUser.AccountListenSub = adminUser.db.usersCollection
    .doc(account)
    .onSnapshot({}, function(doc) {
      var data = doc.data();
      adminUser.accounts = data.accounts;
      adminUser.accountName = data.accountName;
    });
};

adminUser.humanFileSize = function(bytes, si) {
  var thresh = si ? 1000 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  var units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  var u = -1;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
};

adminUser.updateUser = function(db, user) {
  logs.print("user", user);
  this.email = user.email;
  this.name = user.displayName;
  adminUser.getToken(user);
  adminUser.db = db;
  adminUser.fbUser = user;
  adminUser.server = db.config.apiServer;
  adminUser.mediaServer = db.config.mediaApiServer;
  this.pic = user.photoURL;

  setInterval(adminUser.updateTokenID, 1000 * 10 * 60); // get refreshed token every 10 mins
  adminUser.docRef = db.usersCollection.doc(user.email);

  adminUser.updateTokenID();

  return;
  /*
        var docRef = db.usersCollection.doc(user.email);
        docRef.get().then(function (doc) {
            if (doc.exists) {
                var data = doc.data()
                if (data) {
                    if (!data.account || data.account == "") {
                        data.account = user.email;
                    }
                    adminUser.account = data.account
                    adminUser.name = data.name
                }
            }

        }).catch(function (error) {
            console.error("Error getting document:", error);
        });*/
};
adminUser.logout = function() {
  store.state.fb.auth.signOut();
};
adminUser.checkLogin = function() {
  if (!adminUser.started) {
    adminUser.start();
  }
  // logs.print("this.fb.auth.currentUser", this.fb.auth.currentUser)
  if (!this.fb.auth.currentUser) {
    //logs.printin();
  }
};
adminUser.start = function() {
  this.fb = store.state.fb;
  this.fb.auth.onAuthStateChanged((user) => {
    logs.print("onAuthStateChanged", user);
    if (user) {
      store.commit("setCurrentUser", user);
      store.dispatch("fetchUserProfile");
    } else {
      logs.print("LOGIN");
      logs.printin();
    }
    //store.commit('loading', false)
  });
  adminUser.started = true;
};
logs.printin = function() {
  this.error_message = "";
  store.commit("loading", true);
  var fb = this.fb;
  if (!fb.auth.currentUser) {
    // [START createprovider]
    var provider = fb.googleProvider;
    // [END createprovider]
    // [START addscopes]
    provider.addScope("https://www.googleapis.com/auth/plus.login");
    // [END addscopes]
    // [START signin]
    fb.auth
      .signInWithRedirect(provider)
      .then(function(result) {
        logs.print("fb.auth.currentUser", result);
        if (result.user) {
          //reload();
        }
      })
      .catch((err) => console.error("signInWithGoogle:", error));
    // [END signin]
  } else {
    // [START signout]
    fb.auth.signOut();
    // logs.print("logout");
    // [END signout]
  }
};
adminUser.pushUserChanges = function(db) {
  var docRef = db.usersCollection.doc(this.email);
  docRef
    .get()
    .then(function(doc) {
      if (doc.exists) {
        var data = doc.data();
        if (data) {
          data.lastSeen = new Date();
          data.name = adminUser.name;
          docRef.set(data);
        }
      }
    })
    .catch(function(error) {
      console.error("Error getting document:", error);
    });
  /* var doc = db.collection('accounts').doc(adminUser.email);
     doc.set({
         email: adminUser.email
     })*/
};
export { adminUser };
